module.exports = __webpack_public_path__ + "images/category_lp/macbook/main-bg_ddeb3a47e8a1749d9b72f9c65aaa3f7c.png";